import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { EditTechnicalDetails } from 'src/app/api/asset/technical-details/edit-technical-details';
import { TechnicalDetails, toEditModel } from 'src/app/api/asset/technical-details/technical-details';
import { EditFrequencyModel } from './edit-frequency-model';

@Component({
  selector: 'asset-technical-details-edit',
  templateUrl: './asset-technical-details-edit.component.html',
  styleUrl: './asset-technical-details-edit.component.css',
  host: { 'class': 'asset-detail' },
  standalone: false,
})
export class AssetTechnicalDetailsEditComponent implements OnInit {
  id: string | null = null;
  loading: boolean = false;
  saving: boolean = false;
  error: string = '';
  data: TechnicalDetails | null = null;
  editModel: EditTechnicalDetails = {} as EditTechnicalDetails;
  editFrequencyModel: EditFrequencyModel | null = null;
  variantDisplayedColumns: string[] = ['code', 'description', 'instruction', 'actions'];
  electricalDisplayedColumns: string[] = ['printFlag', 'stampFlag', 'voltage', 'frequency', 'connection', 'powerOutput',
    'speed', 'efficiency', 'powerFactor', 'current', 'stallTime', 'torque', 'isIn', 'secondaryVoltage', 'secondaryCurrent',
    'excitationVoltage', 'excitationCurrent', 'connectionRotor', 'actions'];
  frequencyDisplayedColumns: string[] = ['frequency', 'ieClass', 'load50', 'load75', 'load100'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private assetApiService: AssetApiService
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id == null)
      return;

    this.loading = true;
    this.assetApiService.getAssetTechnicalDetails(this.id)
      .subscribe(x => {
        console.log(x);
        this.data = x;
        this.loading = false;
        this.editModel = toEditModel(x);
        console.log(this.editModel);
        this.editFrequencyModel = EditFrequencyModel.fromEntity(x.frequencyParameters);
        console.log(this.editFrequencyModel);
      });
  }

  save(): void {
    this.saving = true;
    this.error = '';
    this.editModel.frequencyParameters = this.editFrequencyModel?.toEntity() ?? [];

    this.assetApiService.updateAssetTechnicalDetails(this.editModel)
      .subscribe({
        next: () => {
          this.saving = false;
          this.router.navigateByUrl('/assets/' + this.id + '#3');
        },
        error: (err) => {
          this.saving = false;
          this.error = err.message || 'Failed to save technical details';
        }
      });
  }

  cancel(): void {
    this.location.back();
  }

  addVariant(): void {
    if (!this.editModel.variants) {
      this.editModel.variants = [];
    }
    const newVariant = { code: '', description: '', instruction: '' };
    this.editModel.variants = [...this.editModel.variants, newVariant];
  }

  removeVariant(index: number): void {
    if (!this.editModel.variants) return;
    this.editModel.variants = this.editModel.variants.filter((_, i) => i !== index);
  }

  addElectricalData(): void {
    if (!this.editModel.electricalData) {
      this.editModel.electricalData = [];
    }
    const newData = {
      printFlag: false,
      stampFlag: false,
      voltage: '',
      frequency: '',
      connection: '',
      powerOutput: 0,
      speed: 0,
      efficiency: 0,
      powerFactor: 0,
      current: 0,
      stallTime: 0,
      torque: 0,
      isIn: 0,
      secondaryVoltage: '',
      secondaryCurrent: '',
      excitationVoltage: '',
      excitationCurrent: '',
      connectionRotor: ''
    };
    this.editModel.electricalData = [...this.editModel.electricalData, newData];
  }

  removeElectricalData(index: number): void {
    if (!this.editModel.electricalData) return;
    this.editModel.electricalData = this.editModel.electricalData.filter((_, i) => i !== index);
  }
}
